import { Injectable, signal } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CardNameService {
  private cardNameSignal = signal<string | null>(null);
  private initialized = false;

  constructor(private router: Router) {}

  get cardName() {
    return this.cardNameSignal.asReadonly();
  }

  setCardName(cardName: string | null) {
    this.cardNameSignal.set(cardName);
  }

  extractCardNameFromUrl(): string | null {
    const url = window.location.pathname;
    const segments = url.split('/').filter(segment => segment);

    const issuingProcessIndex = segments.indexOf('issuing-process');
    if (issuingProcessIndex !== -1 && segments.length > issuingProcessIndex + 1) {
      return segments[issuingProcessIndex + 1];
    }

    return null;
  }

  initializeCardName(cardName?: string | null) {
    if (this.initialized) {
      return; // Already initialized, skip
    }

    if(cardName == null )
      cardName = this.extractCardNameFromUrl();
    if (cardName) {
      this.setCardName(cardName);
    }
    this.initialized = true;
  }

  navigateWithCardName(path: string, queryParams?: any, fragment?: string) {
    // Ensure cardName is initialized before using it
    if (!this.initialized) {
      this.initializeCardName();
    }

    const cardName = this.cardNameSignal();

    let fullPath: string;
    if (cardName) {
      fullPath = `/issuing-process/${cardName}/${path}`;
    } else {
      fullPath = `/issuing-process/${path}`;
    }

    this.router.navigate([fullPath], {
      queryParams,
      fragment,
      queryParamsHandling: 'preserve'
    });
  }

  getBasePath(): string {
    const cardName = this.cardNameSignal();
    return cardName ? `/issuing-process/${cardName}` : '/issuing-process';
  }

  getApiPath(endpoint: string): string {
    const cardName = this.cardNameSignal();
    if (cardName && !endpoint.includes(cardName)) {
      return `${endpoint}/${encodeURIComponent(cardName)}`;
    }
    return endpoint;
  }
}
